<template>
  <section>
    <el-form
      ref="occ-form"
      :rules="rules"
      :disabled="disabled"
      :model="ec_detail">
      <h3 class="color-dark">Employee’s Compensation Details</h3>
      <div
        v-if="!disabled&&!isNewSme"
        class="form-item form-half">
        <span>Any Self-Employed Person(s), Partner or Sole Proprietor for your business?</span>
        <el-form-item
          ref="self_employed_ind"
          prop="self_employed_ind">
          <v-radio-group
            v-model="ec_detail.self_employed_ind"
            :block="true"
            :list="smeYesNoOptions" />
        </el-form-item>
      </div>
      <div
        v-for="(occ,index) in ec_detail.occ_information_list"
        :key="index"
        class="card-border">
        <div
          class="flex-sb-center card-border__content"
          :class="{'mg-b-0':isNewSme}">
          <span
            v-if="!isNewSme"
            class="card-border__title">{{contentTitle}}</span>
          <span
            v-if="index>0&&!disabled"
            class="color-del pointer"
            :class="{'text-left':isNewSme}"
            @click="handlerDelOcc(index)"
          >Delete</span>
        </div>
        <div
          v-if="showOCc"
          class="form-half">
          <div class="form-item ">
            <span >{{ isNewSme?'Occupation / Position':'Occupation' }}</span>
            <el-form-item
              :ref="`occ_information_list.${index}.occ_id`"
              :rules="rules.occ_id"
              :prop="`occ_information_list.${index}.occ_id`">
              <v-select
                v-model="occ.occ_id"
                :block="true"
                :list="occupationList(occ.occ_id)" />
            </el-form-item>
          </div>
        </div>
        <div class="flex-sb-center">
          <div
            v-for="(item,occIndex) in occ.occ_detail"
            :key="`occ_detail${occIndex}`"
            class="form-half bg-gray">
            <div class="form-item pd-b-0">
              <el-form-item
                v-if="!disabled"
                :ref="`occ_information_list.${index}.occ_detail.nature_time_enable`"
                :rules="rules.nature_time_enable"
                :prop="`occ_information_list.${index}.occ_detail.nature_time_enable`">
                <v-checkbox
                  v-model="item.nature_time_enable"
                  :is-boolean="false"
                  :noNumber="2">{{item.nature_time_nm}}</v-checkbox>
              </el-form-item>
              <span v-else>
                {{item.nature_time_nm}}
              </span>
            </div>
            <template v-if="item.nature_time_enable==1||disabled">
              <div class="form-item pd-t-16">
                <span>No. of Employee(s)</span>
                <el-form-item
                  :ref="`occ_information_list.${index}.occ_detail.${occIndex}.no_of_employee`"
                  :rules="rules.no_of_employee"
                  :prop="`occ_information_list.${index}.occ_detail.${occIndex}.no_of_employee`">
                  <v-input
                    v-model="item.no_of_employee"
                    :int="true"
                    :max="30"
                    :key-number="true"
                  />
                </el-form-item>
              </div>
              <div class="form-item ">
                <span>Estimated Annual Earnings</span>
                <el-form-item
                  :ref="`occ_information_list.${index}.occ_detail.${occIndex}.annual_salary`"
                  :rules="rules.annual_salary"
                  :prop="`occ_information_list.${index}.occ_detail.${occIndex}.annual_salary`">
                  <v-input
                    v-model="item.annual_salary"
                    :int="true"
                    :key-number="true"/>
                </el-form-item>
              </div>
            </template>
          </div>
        </div>
      </div>

    </el-form>
    <template v-if="!disabled">
      <v-button
        :gray="!isNewSme"
        :blue="isNewSme"
        icon="add"
        class="mg-b-15"
        @click="handlerAddOcc">{{isNewSme?'Add Occupation':'Add'}}</v-button>
      <div
        v-if="!isNewSme"
        class="form-item form-half mg-t-15">
        <span >Total No. of Employee(s)</span>
        <v-input
          :value="totalEmployee"
          disabled
        />
      </div>
    </template>
  </section>

</template>

<script>
import MixinOptions from '@/mixins/options'
import MixinRules from '@/mixins/rules'
import {mapState} from 'vuex'
import {smeClassId} from '@/utils/smePath'

export default {
  name: 'occuption-underwriting',
  mixins: [MixinOptions, MixinRules],
  props:{
    contentTitle:{
      type:String,
      default:'Occupation'
    },
    form:{
      type:Object,
      default: ()=>({})
    },
    smeClassId:{
      type:Number,
      default:0
    },
    disabled:{
      type:Boolean,
      default:false
    },
    isNewSme:{
      type:Boolean,
      default:false
    }
  },
  data() {
    const checkOpen = (rule, value, callback) => {
      const field_arr = rule.field.split('.')||[]
      const index = field_arr[1]
      const occ_index = field_arr[3]
      const { occ_detail } = this.ec_detail.occ_information_list[index]
      const {nature_time_enable} = occ_detail[occ_index]||{}
      if(nature_time_enable) {
        const valueResult = value !== null && value !== ''
        const { field } = rule
        const require = this.isRequired && this.requireValid

        if(require && !valueResult) {
          callback(new Error(this.$t('placeholder.input')))
        }
        if(this.baseField.includes(field) && !valueResult) {
          callback(new Error(this.$t('placeholder.input')))
        }
        callback()
      }
      callback()
    }
    const checkEmployee = (rule, value, callback) => {
      const field_arr = rule.field.split('.')||[]
      const index = field_arr[1]
      const occ_index = field_arr[3]
      const { occ_detail } = this.ec_detail.occ_information_list[index]
      const {nature_time_enable} = occ_detail[occ_index]||{}
      if(nature_time_enable) {
        const valueResult = value !== null && value !== ''
        const { field } = rule
        const require = this.isRequired && this.requireValid
        if(require && !valueResult||value<=0) {
          callback(new Error(this.$t('placeholder.input')))
        }
        if(this.baseField.includes(field) && !valueResult) {
          callback(new Error(this.$t('placeholder.input')))
        }
        callback()
      }
      callback()
    }
    const checkSelect = (rule, value, callback) => {
      const field_arr = rule.field.split('.')||[]
      const index = field_arr[1]
      // const occ_index = field_arr[3]
      const { occ_detail } = this.ec_detail.occ_information_list[index]
      // const {nature_time_enable} = occ_detail[occ_index]||{}
      let check = occ_detail.find(item=>item.nature_time_enable==1)
      if(!check) {
        callback(new Error(this.$t('placeholder.select')))
      }
      callback()
    }

    return {
      ec_detail: {
        self_employed_ind:null,
        occ_information_list:[]
      },
      rules:{
        nature_time_enable:[
          { validator: checkSelect, trigger: ['change','blur'] }
        ],
        no_of_employee:[
          { validator: checkEmployee, trigger: ['change', 'blur'] }
        ],
        annual_salary:[
          { validator: checkOpen, trigger: ['change', 'blur'] }
        ]
      }
    }
  },
  computed:{
    ...mapState('smeQuote', ['smeQuickForm']),
    occupationList(){
      return (curId) =>{
        const { occ_information_list } = this.ec_detail
        const {ec_occupation=[]} = this.smeOptions
        let arr = []
        if(ec_occupation && ec_occupation.length > 0 ){
          ec_occupation.forEach(item => {
            let index = occ_information_list.findIndex((v)=>{
              return v.occ_id == item.id
            })
            if(index == -1 || curId == item.id){
              arr.push(item)
            }
          })
        }
        return arr
      }
    },
    classId(){
      let {type} = this.$route.params
      return smeClassId[type]||this.smeClassId
    },
    smeOptions(){
      return  this[`smeOptions${this.classId}`]||{}
    },
    showOCc(){
      return [82,83,84,85,86,88].includes(this.classId)||this.isNewSme
    },
    natureList(){
      let {ec_nature} = this.smeOptions
      return ec_nature||[]
    },
    occDetailList(){
      if(this.disabled)
        return []
      let obj = {nature_time_enable:null,annual_salary:0,no_of_employee:0}
      if(this.isNewSme){
        arr = [
          {nature_time:1,...obj,nature_time_nm:'Full Time'},
          {nature_time:2,...obj,nature_time_nm:'Part Time'}
        ]
        return  arr
      }
      let arr = this.natureList.reduce((result,item)=>{
        result.push({nature_time:item.id,...obj,nature_time_nm:item.name})
        return result
      },[])
      return arr
    },
    occObj(){
      return {
        occ_id:null,
        occ_detail:this.occDetailList
      }
    },
    totalEmployee(){
      let {occ_information_list=[]} =this.ec_detail
      let reslut = 0
      occ_information_list.forEach(item=>{
        item.occ_detail.some(occ_item=>{
          reslut = Number(occ_item.no_of_employee)+reslut
        })
      })
      return reslut
    }
  },
  watch: {
    form:{
      immediate:true,
      deep:true,
      handler(val){
        if(val&&!this.isNewSme){
          let {employee} = val
          if(employee){
            console.log('e',employee)
            this.ec_detail.occ_information_list = employee
          }
        }else {
          let {occ_detail_list} = val||{}
          if(occ_detail_list){
            this.ec_detail.occ_information_list = occ_detail_list
          }
          if(this.isNewSme){
            this.ec_detail.occ_information_list.push({...this.occObj})
          }
        }
      }
    }
  },
  mounted() {
    let {ec_detail} = this.smeQuickForm||{}
    if(ec_detail){
      this.ec_detail = ec_detail
    }else
    {
      if(!this.disabled)
      {
        this.ec_detail.occ_information_list.push({...this.occObj})
      }
    }
  },
  methods:{
    handlerAddOcc(){
      let obj = JSON.parse(JSON.stringify(this.occObj))
      this.ec_detail.occ_information_list.push({...obj})
    },
    handlerDelOcc(index){
      this.ec_detail.occ_information_list.splice(index,1)
    },
    subimitLessForm(){
      return new Promise((resolve, reject) => {
        resolve(this.ec_detail)
      })
    },
    submitForm(){
      return new Promise((resolve, reject) => {
        this.$refs['occ-form'].validate((valid, rules) => {
          if(valid){
            resolve(this.ec_detail)
          }else
            reject()
        })
      })
    }
  }
}
</script>

<style scoped lang="scss">
.card-border{
  border-radius: 5px;
  border: 1px solid #e1e4e8;
  padding: 15px;
  margin-bottom: 20px;
  position: relative;
  .card-border__content{
    margin-bottom: 20px;
    &.mg-b-0{
      margin-bottom: 0;
    }
    .card-border__title{
      font-family: 'Inter';
      font-style: normal;
      font-weight: 600;
      font-size: 16px;
      line-height: 24px;
      color: #24292E;
      display: inline-block;
    }
    .text-left{
      position: absolute;
      right: 15px;
      top: 15px;
    }
  }
  .flex-sb-center{
    flex-wrap: wrap;
    .bg-gray{
      margin-bottom: 20px;
      &:nth-last-child(2){
        margin-bottom: 0;
      }
      &:last-child{
        margin-bottom: 0;
      }
    }
  }

  .bg-gray{
    background: #F6F8FA;
    border-radius: 6px;
    padding: 15px;
    align-self: flex-start;
  }
}
/deep/.el-checkbox__input.is-checked+.el-checkbox__label {
  color: #24292E;
  font-weight: 600;
}
/deep/.el-checkbox__label {
  color: #24292E;
  font-weight: 600;
}
</style>
